import React from 'react'
import { API_BASE } from '../config'
import { photoUrl } from '../utils/photoUrl'

// Short date like "27 Jun" / "07 Oct 2026"
const _MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
const fmtShort = d => { try { const x = new Date(d); return `${x.getDate()} ${_MON[x.getMonth()]}` } catch { return '' } }
const fmtNice = d => { try { const x = new Date(d); return `${String(x.getDate()).padStart(2,'0')} ${_MON[x.getMonth()]} ${x.getFullYear()}` } catch { return '' } }

const G = {
  g900: '#0D2218', g800: '#1A3A28', g700: '#235233', g600: '#2D6B42',
  g500: '#3D8A57', g300: '#85C99A', g100: '#E8F5EE', g50: '#F5FAF7',
  mute: '#8a9a92', text: '#1A2820', border: '#EAF1ED',
  headerGrad: 'linear-gradient(150deg,#0F3D24 0%,#1E6B3C 60%,#2E8B4F 100%)',
}
const FONT = "'DM Sans',sans-serif"
const SERIF = "'DM Serif Display',serif"

const firstName = (u) => {
  const n = (u?.name || '').trim()
  if (n) return n.split(/\s+/)[0]
  const e = u?.email || ''
  return e ? e.split('@')[0] : 'there'
}

const EXPLORE = [
  ['🛍️', 'Shop\nSkincare',    '/shop'],
  ['🛡️', 'Why\nRevive?',     '/about'],
  ['▶️',  'How It\nWorks',    '/about'],
  ['⭐',  'Success\nStories', '/about'],
]

// ── Stage 1: brand-new user, no consultation yet ──
function NewUserHome({ user, notifs, onDismissNotif, onBookConsult, onSkinScan, onExplore }) {
  return (
    <div style={{ minHeight: '100vh', background: '#F8FAF9', fontFamily: FONT, paddingBottom: 90 }}>

      {/* Top bar */}
      <div style={{ padding: '3rem 1.2rem .8rem', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontFamily: SERIF, fontSize: '1.4rem', color: G.g700, letterSpacing: '-.01em' }}>Revive</div>
        <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
          <span style={{ fontSize: '1.2rem', cursor: 'pointer' }}>🔔</span>
          <span style={{ fontSize: '1.2rem', cursor: 'pointer' }}>🛒</span>
        </div>
      </div>

      <div style={{ padding: '1.1rem 1.2rem 0' }}>
        <NotifBanner notifs={notifs} onDismiss={onDismissNotif} />

        {/* Welcome text */}
        <div style={{ marginBottom: '1.1rem' }}>
          <div style={{ fontSize: '1rem', fontWeight: 600, color: G.text }}>Welcome to Revive 👋</div>
          <div style={{ fontSize: '1.65rem', fontWeight: 800, color: G.text, lineHeight: 1.2, marginTop: 4 }}>
            Let's start your<br /><span style={{ color: G.g600 }}>skin journey.</span>
          </div>
        </div>

        {/* AI Skin Analysis card */}
        <button onClick={onSkinScan}
          style={{ display: 'flex', alignItems: 'center', gap: 14, width: '100%', textAlign: 'left', background: '#fff', border: `1.5px solid ${G.border}`, borderRadius: 18, padding: '1rem 1.15rem', boxShadow: '0 2px 12px rgba(13,34,24,.06)', cursor: 'pointer', fontFamily: FONT, marginBottom: 12 }}>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: G.g100, border: `1.5px dashed ${G.g300}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.7rem', flexShrink: 0 }}>🤳</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '1rem', fontWeight: 700, color: G.text }}>AI Skin Analysis</div>
            <div style={{ fontSize: '.78rem', color: G.mute, marginTop: 3, lineHeight: 1.4 }}>Scan your skin and get AI<br />insights in seconds.</div>
          </div>
          <span style={{ color: G.mute, fontSize: '1.2rem' }}>→</span>
        </button>

        {/* Book Consultation — big green button */}
        <button onClick={onBookConsult}
          style={{ width: '100%', background: G.g700, border: 'none', borderRadius: 18, padding: '1.1rem 1.4rem', cursor: 'pointer', fontFamily: FONT, boxShadow: '0 6px 20px rgba(35,82,51,.3)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '1.05rem', fontWeight: 800, color: '#fff' }}>Book Consultation</div>
            <div style={{ fontSize: '.75rem', color: 'rgba(255,255,255,.65)', marginTop: 3 }}>Talk to a dermatologist online</div>
          </div>
          <span style={{ color: 'rgba(255,255,255,.7)', fontSize: '1.2rem' }}>→</span>
        </button>

        {/* Explore Revive */}
        <div style={{ marginTop: 20 }}>
          <div style={{ fontSize: '.95rem', fontWeight: 700, color: G.text, marginBottom: '1rem' }}>Explore Revive</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 10 }}>
            {EXPLORE.map(([ic, label, path]) => (
              <button key={label} onClick={() => onExplore && onExplore(path)}
                style={{ background: '#fff', border: `1px solid ${G.border}`, borderRadius: 14, padding: '.85rem .5rem', textAlign: 'center', cursor: 'pointer', fontFamily: FONT, boxShadow: '0 1px 6px rgba(13,34,24,.04)' }}>
                <div style={{ fontSize: '1.4rem', marginBottom: 6 }}>{ic}</div>
                <div style={{ fontSize: '.65rem', fontWeight: 600, color: G.text, lineHeight: 1.3, whiteSpace: 'pre-line' }}>{label}</div>
              </button>
            ))}
          </div>
        </div>

        {/* Chat card */}
        <div style={{ marginTop: 14, background: '#fff', border: `1px solid ${G.border}`, borderRadius: 18, padding: '1rem 1.2rem', display: 'flex', alignItems: 'center', gap: 12, boxShadow: '0 1px 6px rgba(13,34,24,.04)' }}>
          <div style={{ width: 42, height: 42, borderRadius: 12, background: G.g100, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.3rem', flexShrink: 0 }}>💬</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '.88rem', fontWeight: 700, color: G.text }}>Questions about your skin?</div>
            <div style={{ fontSize: '.72rem', color: G.mute, marginTop: 2 }}>Chat with our care team</div>
          </div>
          <button onClick={() => onExplore && onExplore('/contact')}
            style={{ background: 'none', border: `1.5px solid ${G.g500}`, borderRadius: 10, padding: '.4rem .85rem', color: G.g600, fontWeight: 700, fontSize: '.78rem', cursor: 'pointer', fontFamily: FONT, whiteSpace: 'nowrap' }}>
            Chat Now
          </button>
        </div>

      </div>
    </div>
  )
}

// ── Stage 2: appointment booked, waiting for consultation ──
function ApptBookedHome({ user, appt, notifs, onDismissNotif, onSkinScan, onExplore, onMessages }) {
  const fmtApptDate = (raw) => {
    try {
      const d = new Date((raw || '').replace(' ', 'T').split('T')[0] + 'T00:00:00')
      return d.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
    } catch { return raw || '—' }
  }
  const daysUntil = React.useMemo(() => {
    try {
      const apptDate = new Date((appt.date || '').replace(' ', 'T').split('T')[0] + 'T00:00:00')
      const today = new Date(); today.setHours(0, 0, 0, 0)
      return Math.round((apptDate - today) / 86400000)
    } catch { return null }
  }, [appt?.date])

  const countdown = daysUntil === null ? null
    : daysUntil === 0 ? { label: 'Today!', color: G.g600 }
    : daysUntil === 1 ? { label: 'Tomorrow', color: '#B7770D' }
    : daysUntil > 1 ? { label: `In ${daysUntil} days`, color: G.mute }
    : { label: 'Past', color: G.mute }

  const PREP = [
    ['📸', 'Take clear photos of your skin now', 'So the doctor can see the baseline before your call'],
    ['📝', 'Note your symptoms & concerns', 'How long, what triggers, what you\'ve tried'],
    ['💡', 'Prepare your questions', 'Write down anything you want to ask the doctor'],
    ['🌞', 'Be in good lighting', 'Helps the doctor see your skin clearly during video'],
  ]

  return (
    <div style={{ minHeight: '100vh', background: '#F8FAF9', fontFamily: FONT, paddingBottom: 90 }}>

      {/* Top bar */}
      <div style={{ padding: '3rem 1.2rem .8rem', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontFamily: SERIF, fontSize: '1.4rem', color: G.g700 }}>Revive</div>
        <div style={{ display: 'flex', gap: 14 }}>
          <span style={{ fontSize: '1.2rem', cursor: 'pointer' }}>🔔</span>
          <span style={{ fontSize: '1.2rem', cursor: 'pointer' }}>🛒</span>
        </div>
      </div>

      <div style={{ padding: '1.1rem 1.2rem 0' }}>
        <NotifBanner notifs={notifs} onDismiss={onDismissNotif} />

        {/* Greeting */}
        <div style={{ marginBottom: '1.1rem' }}>
          <div style={{ fontSize: '1.1rem', fontWeight: 600, color: G.text }}>Hi {firstName(user)} 👋</div>
          <div style={{ fontSize: '1.5rem', fontWeight: 800, color: G.text, lineHeight: 1.2, marginTop: 4 }}>
            Your consultation<br />is <span style={{ color: G.g600 }}>confirmed!</span>
          </div>
        </div>

        {/* Appointment card */}
        <div style={{ background: '#fff', border: `1.5px solid ${G.border}`, borderRadius: 20, overflow: 'hidden', boxShadow: '0 4px 18px rgba(13,34,24,.07)', marginBottom: 12 }}>
          <div style={{ background: G.headerGrad, padding: '1rem 1.3rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: '.6rem', color: 'rgba(255,255,255,.5)', textTransform: 'uppercase', letterSpacing: '.1em' }}>Your Appointment</div>
              <div style={{ fontSize: '1.05rem', fontWeight: 700, color: '#fff', marginTop: 3 }}>{appt.service || 'Dermatology Consultation'}</div>
            </div>
            <div style={{ background: 'rgba(255,255,255,.15)', borderRadius: 8, padding: '.3rem .7rem', fontSize: '.7rem', fontWeight: 700, color: '#fff', textTransform: 'capitalize' }}>
              {appt.status || 'Confirmed'}
            </div>
          </div>
          <div style={{ padding: '1rem 1.3rem', display: 'flex', flexDirection: 'column', gap: '.6rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ fontSize: '1.1rem' }}>📅</span>
              <div>
                <div style={{ fontSize: '.88rem', fontWeight: 600, color: G.text }}>{fmtApptDate(appt.date)}</div>
                {appt.timeSlot && <div style={{ fontSize: '.75rem', color: G.mute, marginTop: 1 }}>{appt.timeSlot}</div>}
              </div>
              {countdown && (
                <div style={{ marginLeft: 'auto', fontSize: '.78rem', fontWeight: 700, color: countdown.color, background: countdown.color === G.g600 ? G.g100 : '#FFF8E1', borderRadius: 8, padding: '.3rem .7rem' }}>
                  {countdown.label}
                </div>
              )}
            </div>
            {appt.mode && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: '1.1rem' }}>{appt.mode === 'online' ? '💻' : '🏥'}</span>
                <div style={{ fontSize: '.85rem', color: G.text, fontWeight: 500, textTransform: 'capitalize' }}>{appt.mode} consultation</div>
              </div>
            )}
            {appt.mode === 'online' && (
              <a href={appt.meetLink || `https://meet.jit.si/revive-${appt.id}`}
                target="_blank" rel="noopener noreferrer"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, background: '#1A73E8', color: '#fff', borderRadius: 12, padding: '.75rem', fontWeight: 700, fontSize: '.88rem', textDecoration: 'none', fontFamily: FONT }}>
                📹 Join Video Call
              </a>
            )}
          </div>
        </div>

        {/* Prepare card */}
        <div style={{ background: '#fff', border: `1px solid ${G.border}`, borderRadius: 20, padding: '1.1rem 1.3rem', marginBottom: 12, boxShadow: '0 2px 10px rgba(13,34,24,.04)' }}>
          <div style={{ fontSize: '.82rem', fontWeight: 700, color: G.text, marginBottom: '1rem' }}>Prepare for your consultation</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '.85rem' }}>
            {PREP.map(([ic, title, sub]) => (
              <div key={title} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <div style={{ width: 36, height: 36, borderRadius: 10, background: G.g100, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', flexShrink: 0 }}>{ic}</div>
                <div>
                  <div style={{ fontSize: '.85rem', fontWeight: 600, color: G.text }}>{title}</div>
                  <div style={{ fontSize: '.72rem', color: G.mute, marginTop: 2, lineHeight: 1.4 }}>{sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* AI Skin Analysis CTA */}
        <button onClick={onSkinScan}
          style={{ display: 'flex', alignItems: 'center', gap: 14, width: '100%', textAlign: 'left', background: `linear-gradient(135deg,${G.g700},${G.g500})`, border: 'none', borderRadius: 18, padding: '1rem 1.3rem', marginBottom: 12, cursor: 'pointer', fontFamily: FONT, boxShadow: '0 4px 16px rgba(35,82,51,.2)' }}>
          <div style={{ width: 44, height: 44, borderRadius: 12, background: 'rgba(255,255,255,.16)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem', flexShrink: 0 }}>🔬</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '.95rem', fontWeight: 700, color: '#fff' }}>AI Skin Analysis</div>
            <div style={{ fontSize: '.72rem', color: 'rgba(255,255,255,.7)', marginTop: 2 }}>Do it before the consultation for best results</div>
          </div>
          <span style={{ color: 'rgba(255,255,255,.6)', fontSize: '1.2rem' }}>→</span>
        </button>

        {/* Chat */}
        <div style={{ background: '#fff', border: `1px solid ${G.border}`, borderRadius: 18, padding: '1rem 1.2rem', display: 'flex', alignItems: 'center', gap: 12, boxShadow: '0 1px 6px rgba(13,34,24,.04)' }}>
          <div style={{ width: 40, height: 40, borderRadius: 12, background: G.g100, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', flexShrink: 0 }}>💬</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '.85rem', fontWeight: 700, color: G.text }}>Questions before your call?</div>
            <div style={{ fontSize: '.72rem', color: G.mute, marginTop: 2 }}>Chat with our care team</div>
          </div>
          <button onClick={onMessages}
            style={{ background: 'none', border: `1.5px solid ${G.g500}`, borderRadius: 10, padding: '.4rem .85rem', color: G.g600, fontWeight: 700, fontSize: '.78rem', cursor: 'pointer', fontFamily: FONT, whiteSpace: 'nowrap' }}>
            Chat Now
          </button>
        </div>

      </div>
    </div>
  )
}

export default function MobileHome({ user, treatment, patientState, latestAppt, appointments = [], fetchWithAuth, navigate, notifs = [], onDismissNotif, onOpenPrescription, onOpenPlan, onOpenReminders, onOpenProgress, onOpenAppointments, onMessages, onNavHome, onNavProgress, onNavShop, onSkinScan, onExplore, onOpenDetail }) {
  // ── Journey state routing ──
  switch (patientState) {
    case 'NEW_USER':
      return <NewUserHome user={user} notifs={notifs} onDismissNotif={onDismissNotif} onBookConsult={onOpenAppointments} onSkinScan={onSkinScan} onExplore={onExplore} />
    case 'APPT_BOOKED':
      return <ApptBookedHome user={user} appt={latestAppt} notifs={notifs} onDismissNotif={onDismissNotif} onSkinScan={onSkinScan} onExplore={onExplore} onMessages={onMessages} />
    case 'CARE_PLAN_CREATED':
      return <CarePlanHome user={user} treatment={treatment} notifs={notifs} onDismissNotif={onDismissNotif} onOpenReminders={onOpenReminders} onOpenPrescription={onOpenPrescription} onOpenPlan={onOpenPlan || onOpenPrescription} onMessages={onMessages} />
    case 'FOLLOW_UP_DUE':
    case 'ACTIVE_TREATMENT':
      return <ActiveTreatmentHome user={user} treatment={treatment} notifs={notifs} onDismissNotif={onDismissNotif} onOpenReminders={onOpenReminders} onOpenPrescription={onOpenPrescription} onOpenPlan={onOpenPlan || onOpenPrescription} onOpenProgress={onOpenProgress} onMessages={onMessages} onBookConsult={onOpenAppointments} followUpDue={patientState === 'FOLLOW_UP_DUE'} />
    case 'TREATMENT_COMPLETED':
      return <TreatmentCompleteHome user={user} treatment={treatment} appointments={appointments} fetchWithAuth={fetchWithAuth} navigate={navigate} notifs={notifs} onDismissNotif={onDismissNotif} onOpenProgress={onOpenProgress} onBookConsult={onOpenAppointments} onExplore={onExplore} />
    default:
      return <NewUserHome user={user} notifs={notifs} onDismissNotif={onDismissNotif} onBookConsult={onOpenAppointments} onSkinScan={onSkinScan} onExplore={onExplore} />
  }
}

// ── Shared top bar ──
function TopBar({ label }) {
  return (
    <div style={{ padding: '3rem 1.2rem .8rem', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <div style={{ fontFamily: SERIF, fontSize: '1.4rem', color: G.g700 }}>{label || 'Revive'}</div>
      <div style={{ display: 'flex', gap: 14 }}>
        <span style={{ fontSize: '1.2rem' }}>🔔</span>
        <span style={{ fontSize: '1.2rem' }}>🛒</span>
      </div>
    </div>
  )
}


function NotifBanner({ notifs, onDismiss }) {
  if (!notifs?.length) return null
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '.5rem', marginBottom: 12 }}>
      {notifs.map(n => (
        <div key={n.id} style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 14, padding: '.8rem 1rem', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '.75rem' }}>
          <div style={{ display: 'flex', gap: '.55rem' }}>
            <span style={{ fontSize: '1.1rem' }}>💊</span>
            <div>
              <div style={{ fontWeight: 700, color: '#B91C1C', fontSize: '.82rem' }}>{n.title}</div>
              <div style={{ fontSize: '.75rem', color: '#7F1D1D', marginTop: 2, lineHeight: 1.4 }}>{n.body}</div>
            </div>
          </div>
          <button onClick={() => onDismiss && onDismiss(n.id)} style={{ background: 'none', border: 'none', color: '#B91C1C', fontSize: '1.1rem', cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
      ))}
    </div>
  )
}

// ── Stage 3: care plan just created (day 0–1) ──
function CarePlanHome({ user, treatment, notifs, onDismissNotif, onOpenReminders, onOpenPrescription, onOpenPlan, onMessages }) {
  const appt = treatment?.appt
  const doctorNote = appt?.diagnosis || appt?.prescription || ''
  const shortNote = doctorNote.split('\n').filter(Boolean).slice(0, 2).join(' · ')

  const SLOTS = [
    { label: 'Morning', icon: '🌅', time: '9:00 AM' },
    { label: 'Afternoon', icon: '☀️', time: '2:00 PM' },
    { label: 'Night', icon: '🌙', time: '9:00 PM' },
  ]

  return (
    <div style={{ minHeight: '100vh', background: '#F8FAF9', fontFamily: FONT, paddingBottom: 90 }}>
      <TopBar />
      <div style={{ padding: '1.1rem 1.2rem 0' }}>
        <NotifBanner notifs={notifs} onDismiss={onDismissNotif} />

        <div style={{ marginBottom: '1.1rem' }}>
          <div style={{ fontSize: '1rem', fontWeight: 600, color: G.text }}>Hi {firstName(user)} 👋</div>
          <div style={{ fontSize: '1.5rem', fontWeight: 800, color: G.text, lineHeight: 1.2, marginTop: 4 }}>
            Your treatment<br />has <span style={{ color: G.g600 }}>started!</span>
          </div>
          <div style={{ fontSize: '.85rem', color: G.mute, marginTop: 5 }}>Follow your plan and we will be with you.</div>
        </div>

        {/* Treatment Plan card */}
        <button onClick={onOpenPlan} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', background: '#fff', border: `1.5px solid ${G.border}`, borderRadius: 18, padding: '1rem 1.3rem', marginBottom: 12, cursor: 'pointer', fontFamily: FONT, boxShadow: '0 2px 10px rgba(13,34,24,.05)', textAlign: 'left' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 44, height: 44, borderRadius: 12, background: G.g100, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.3rem' }}>📋</div>
            <div>
              <div style={{ fontSize: '.68rem', color: G.mute, textTransform: 'uppercase', letterSpacing: '.08em' }}>Your Treatment Plan</div>
              <div style={{ fontSize: '1rem', fontWeight: 700, color: G.text, marginTop: 2 }}>{treatment?.name || 'Care Plan'}</div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: G.g600, fontWeight: 700, fontSize: '.82rem' }}>View Plan <span>›</span></div>
        </button>

        {/* Today's Medicines */}
        <div style={{ background: '#fff', border: `1px solid ${G.border}`, borderRadius: 18, padding: '1rem 1.3rem', marginBottom: 12, boxShadow: '0 2px 10px rgba(13,34,24,.05)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <div style={{ fontSize: '.88rem', fontWeight: 700, color: G.text }}>Today's Medicines</div>
            <button onClick={onOpenReminders} style={{ fontSize: '.72rem', color: G.g600, fontWeight: 700, background: 'none', border: 'none', cursor: 'pointer', fontFamily: FONT }}>See all</button>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '.75rem' }}>
            {SLOTS.map(({ label, icon, time }) => (
              <div key={label} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ fontSize: '1.1rem' }}>{icon}</span>
                  <div>
                    <div style={{ fontSize: '.88rem', fontWeight: 600, color: G.text }}>{label}</div>
                    <div style={{ fontSize: '.72rem', color: G.mute }}>{time}</div>
                  </div>
                </div>
                <div style={{ fontSize: '.72rem', fontWeight: 700, color: '#B7770D', background: '#FFF8E1', borderRadius: 8, padding: '.25rem .65rem' }}>Upcoming</div>
              </div>
            ))}
          </div>
        </div>

        {/* Doctor Note */}
        {shortNote ? (
          <div style={{ background: '#fff', border: `1px solid ${G.border}`, borderRadius: 18, padding: '1rem 1.3rem', marginBottom: 12, boxShadow: '0 2px 10px rgba(13,34,24,.05)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '.6rem' }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: G.g100, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem' }}>👩‍⚕️</div>
              <div style={{ fontSize: '.88rem', fontWeight: 700, color: G.text }}>Doctor Note</div>
            </div>
            <div style={{ fontSize: '.82rem', color: '#3a4a42', lineHeight: 1.6 }}>{shortNote}</div>
          </div>
        ) : null}

        {/* Chat */}
        <div style={{ background: '#fff', border: `1px solid ${G.border}`, borderRadius: 18, padding: '1rem 1.2rem', display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
          <div style={{ width: 40, height: 40, borderRadius: 12, background: G.g100, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', flexShrink: 0 }}>💬</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '.85rem', fontWeight: 700, color: G.text }}>Questions about your plan?</div>
            <div style={{ fontSize: '.72rem', color: G.mute, marginTop: 2 }}>Chat with our care team</div>
          </div>
          <button onClick={onMessages} style={{ background: 'none', border: `1.5px solid ${G.g500}`, borderRadius: 10, padding: '.4rem .85rem', color: G.g600, fontWeight: 700, fontSize: '.78rem', cursor: 'pointer', fontFamily: FONT, whiteSpace: 'nowrap' }}>Chat Now</button>
        </div>

      </div>
    </div>
  )
}

// ── Stage 4: active treatment (day 2+) ──
function ActiveTreatmentHome({ user, treatment, notifs, onDismissNotif, onOpenReminders, onOpenPrescription, onOpenPlan, onOpenProgress, onMessages, onBookConsult, followUpDue }) {
  const appt = treatment?.appt
  const daysLeft = treatment ? treatment.planDays - treatment.dayNum : 0

  const MILESTONES = React.useMemo(() => {
    if (!treatment) return []
    const { dayNum, planDays } = treatment
    const weeks = Math.ceil(planDays / 7)
    const currentWeek = Math.ceil(dayNum / 7)
    const items = []
    for (let w = 1; w <= Math.min(weeks, 4); w++) {
      items.push({ label: `Week ${w}`, done: dayNum >= w * 7, current: currentWeek === w })
    }
    return items
  }, [treatment])

  const CARE_SLOTS = [
    { label: 'Morning', icon: '🌅', sub: '9:00 AM' },
    { label: 'Afternoon', icon: '☀️', sub: '2:00 PM' },
    { label: 'Night', icon: '🌙', sub: '9:00 PM' },
  ]

  return (
    <div style={{ minHeight: '100vh', background: '#F8FAF9', fontFamily: FONT, paddingBottom: 90 }}>
      <TopBar />
      <div style={{ padding: '1.1rem 1.2rem 0' }}>
        <NotifBanner notifs={notifs} onDismiss={onDismissNotif} />

        {/* Follow-up due banner */}
        {followUpDue && (
          <div style={{ background: `linear-gradient(135deg,#FFF8E1,#FFF3CD)`, border: '1.5px solid #FFE082', borderRadius: 18, padding: '1rem 1.2rem', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: '1.4rem' }}>📅</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '.88rem', fontWeight: 700, color: '#8D6E00' }}>Time for your follow-up!</div>
              <div style={{ fontSize: '.72rem', color: '#A07800', marginTop: 2 }}>Your treatment is almost complete. Book a review.</div>
            </div>
            <button onClick={onBookConsult} style={{ background: '#B7770D', color: '#fff', border: 'none', borderRadius: 10, padding: '.45rem .9rem', fontWeight: 700, fontSize: '.75rem', cursor: 'pointer', fontFamily: FONT, whiteSpace: 'nowrap' }}>Book Now</button>
          </div>
        )}

        {/* Treatment progress — tap to open full plan */}
        <div onClick={onOpenPlan} role="button" style={{ background: '#fff', border: `1px solid ${G.border}`, borderRadius: 18, padding: '1.1rem 1.25rem', marginBottom: 12, boxShadow: '0 4px 16px rgba(13,34,24,.06)', cursor: 'pointer' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '.7rem' }}>
            <div>
              <div style={{ fontSize: '.66rem', color: G.mute, textTransform: 'uppercase', letterSpacing: '.06em' }}>Active Treatment</div>
              <div style={{ fontSize: '1.15rem', fontWeight: 800, color: G.g900, marginTop: 3 }}>{treatment?.name}</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{ background: G.g100, color: G.g600, fontSize: '.68rem', fontWeight: 700, borderRadius: 8, padding: '.25rem .65rem', border: `1px solid ${G.g300}` }}>Active</div>
              <span style={{ color: G.mute, fontSize: '.95rem', fontWeight: 700 }}>›</span>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginBottom: 4 }}>
            <span style={{ fontSize: '2rem', fontWeight: 800, color: G.g700 }}>{treatment?.pct}%</span>
            <span style={{ fontSize: '.78rem', color: G.mute }}>Completed</span>
          </div>
          <div style={{ height: 8, background: '#E8F1EC', borderRadius: 999, overflow: 'hidden', marginBottom: 6 }}>
            <div style={{ height: '100%', width: `${treatment?.pct}%`, background: G.g500, borderRadius: 999, transition: 'width .4s' }} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '.72rem', color: G.mute }}>
            <span>Day {treatment?.dayNum} of {treatment?.planDays}</span>
            <span>{daysLeft} days left</span>
          </div>
          {/* Milestones row */}
          {MILESTONES.length > 0 && (
            <div style={{ display: 'flex', gap: 6, marginTop: 10, flexWrap: 'wrap' }}>
              {MILESTONES.map(m => (
                <div key={m.label} style={{ fontSize: '.65rem', fontWeight: 700, padding: '.2rem .55rem', borderRadius: 999, background: m.done ? G.g100 : m.current ? '#FFF8E1' : '#F3F4F6', color: m.done ? G.g600 : m.current ? '#B7770D' : G.mute, border: `1px solid ${m.done ? G.g300 : m.current ? '#FFE082' : G.border}` }}>
                  {m.done ? '✓ ' : m.current ? '→ ' : ''}{m.label}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Today's Care */}
        <div style={{ background: '#fff', border: `1px solid ${G.border}`, borderRadius: 18, padding: '1rem 1.3rem', marginBottom: 12, boxShadow: '0 2px 10px rgba(13,34,24,.05)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <div style={{ fontSize: '.88rem', fontWeight: 700, color: G.text }}>Today's Care</div>
            <button onClick={onOpenReminders} style={{ fontSize: '.72rem', color: G.g600, fontWeight: 700, background: 'none', border: 'none', cursor: 'pointer', fontFamily: FONT }}>See all</button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 }}>
            {CARE_SLOTS.map(({ label, icon, sub }) => (
              <div key={label} style={{ background: G.g50, borderRadius: 14, padding: '.85rem .6rem', textAlign: 'center' }}>
                <div style={{ fontSize: '1.3rem', marginBottom: 4 }}>{icon}</div>
                <div style={{ fontSize: '.75rem', fontWeight: 700, color: G.text }}>{label}</div>
                <div style={{ fontSize: '.65rem', color: G.mute, marginTop: 2 }}>{sub}</div>
              </div>
            ))}
          </div>
          <button onClick={onOpenReminders} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, width: '100%', marginTop: 10, background: G.g700, color: '#fff', border: 'none', borderRadius: 12, padding: '.7rem', fontWeight: 700, fontSize: '.85rem', cursor: 'pointer', fontFamily: FONT }}>
            💊 Mark Today's Doses
          </button>
        </div>

        {/* Doctor Note */}
        {(appt?.diagnosis || appt?.prescription) && (
          <button onClick={onOpenPrescription} style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left', background: '#fff', border: `1px solid ${G.border}`, borderRadius: 18, padding: '1rem 1.3rem', marginBottom: 12, cursor: 'pointer', fontFamily: FONT, boxShadow: '0 2px 10px rgba(13,34,24,.05)' }}>
            <div style={{ width: 40, height: 40, borderRadius: 12, background: G.g100, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem', flexShrink: 0 }}>👩‍⚕️</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '.88rem', fontWeight: 700, color: G.text }}>Doctor Note</div>
              <div style={{ fontSize: '.72rem', color: G.mute, marginTop: 2, lineHeight: 1.4 }}>{(appt?.diagnosis || appt?.prescription || '').split('\n').filter(Boolean)[0]?.slice(0, 60)}…</div>
            </div>
            <span style={{ color: G.mute, fontSize: '1.1rem' }}>›</span>
          </button>
        )}

        {/* Progress Photos */}
        <button onClick={onOpenProgress} style={{ display: 'flex', alignItems: 'center', gap: 14, width: '100%', textAlign: 'left', background: `linear-gradient(135deg,${G.g700},${G.g500})`, border: 'none', borderRadius: 16, padding: '1rem 1.3rem', marginBottom: 12, cursor: 'pointer', fontFamily: FONT, boxShadow: '0 4px 16px rgba(35,82,51,.2)' }}>
          <div style={{ width: 44, height: 44, borderRadius: 12, background: 'rgba(255,255,255,.16)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem', flexShrink: 0 }}>📸</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '.95rem', fontWeight: 700, color: '#fff' }}>Progress Photos</div>
            <div style={{ fontSize: '.72rem', color: 'rgba(255,255,255,.7)', marginTop: 2 }}>Track how your skin is improving</div>
          </div>
          <span style={{ color: 'rgba(255,255,255,.6)', fontSize: '1.2rem' }}>›</span>
        </button>

      </div>
    </div>
  )
}

// ── Stage 6: treatment complete ──
function TreatmentCompleteHome({ user, treatment, appointments = [], fetchWithAuth, navigate, notifs, onDismissNotif, onOpenProgress, onBookConsult, onExplore }) {
  // ── Real progress photos across all appointments (newest first) ──
  const progressPhotos = React.useMemo(() => {
    const all = []
    appointments.forEach(a => {
      let pp = []
      try { pp = typeof a.progressPhotos === 'string' ? JSON.parse(a.progressPhotos || '[]') : (Array.isArray(a.progressPhotos) ? a.progressPhotos : []) } catch {}
      pp.forEach(f => { const ts = parseInt(String(f).split('-')[0]); all.push({ file: f, ts: isNaN(ts) ? 0 : ts }) })
    })
    return all.sort((x, y) => y.ts - x.ts)
  }, [appointments])
  const photoCount = progressPhotos.length
  const lastPhotoTs = photoCount ? progressPhotos[0].ts : null
  const daysSincePhoto = lastPhotoTs ? Math.floor((Date.now() - lastPhotoTs) / 86400000) : null

  // ── Dates ──
  const asc = React.useMemo(() => appointments.slice().sort((a, b) => new Date(a.date) - new Date(b.date)), [appointments])
  const firstAppt = asc[0]
  const completedAppt = React.useMemo(() => appointments.filter(a => a.status === 'completed').sort((a, b) => new Date(b.date) - new Date(a.date))[0], [appointments])
  const diagAppt = appointments.find(a => a.diagnosis) || firstAppt
  const startISO = treatment?.appt?.date ? String(treatment.appt.date).slice(0, 10) : (firstAppt ? String(firstAppt.date).slice(0, 10) : null)
  const completedISO = completedAppt?.followUpDate ? String(completedAppt.followUpDate).slice(0, 10) : (completedAppt ? String(completedAppt.date).slice(0, 10) : null)
  const daysCompleted = (treatment?.planDays && treatment.planDays >= 3 && treatment.planDays <= 180)
    ? treatment.planDays
    : (startISO && completedISO ? Math.max(0, Math.round((new Date(completedISO) - new Date(startISO)) / 86400000)) : null)
  const daysSinceCompleted = completedISO ? Math.max(0, Math.floor((Date.now() - new Date(completedISO + 'T00:00:00')) / 86400000)) : null

  // ── Health logs + doctor review → same Skin Score & review date as My Care ──
  const [healthLogs, setHealthLogs] = React.useState([])
  React.useEffect(() => {
    if (!fetchWithAuth) return
    fetchWithAuth(`${API_BASE}/api/health/logs?days=30`).then(r => r.ok ? r.json() : { logs: [] }).then(d => setHealthLogs(Array.isArray(d?.logs) ? d.logs : [])).catch(() => {})
  }, [fetchWithAuth])
  const [lastReview, setLastReview] = React.useState(null)
  React.useEffect(() => {
    const target = treatment?.appt || appointments.slice().sort((a, b) => new Date(b.date) - new Date(a.date))[0]
    if (!fetchWithAuth || !target?.id) return
    fetchWithAuth(`${API_BASE}/api/appointments/${target.id}/photo-reviews`).then(r => r.ok ? r.json() : { reviews: [] }).then(d => setLastReview((Array.isArray(d?.reviews) ? d.reviews : [])[0] || null)).catch(() => {})
  }, [fetchWithAuth, treatment, appointments])

  const skinScore = React.useMemo(() => {
    const photos = !photoCount ? 0 : daysSincePhoto <= 7 ? 45 : daysSincePhoto <= 14 ? 36 : daysSincePhoto <= 30 ? 27 : 18
    const lifestyle = healthLogs.length >= 7 ? 30 : healthLogs.length >= 3 ? 21 : healthLogs.length >= 1 ? 12 : 0
    const doctor = (appointments.some(a => a.status === 'completed') || lastReview) ? 25 : 0
    return photos + lifestyle + doctor
  }, [photoCount, daysSincePhoto, healthLogs, appointments, lastReview])

  // ── Recommended review date (driven by the doctor's latest verdict) ──
  const rec = React.useMemo(() => {
    const future = appointments.filter(a => ['pending', 'confirmed'].includes(a.status) && new Date(a.date) > new Date())
    if (future.length) return { date: future.sort((a, b) => new Date(a.date) - new Date(b.date))[0].date, booked: true }
    if (lastReview) { const days = { worse: 7, same: 28, improving: 90 }[lastReview.verdict] ?? 90; const d = new Date(lastReview.createdAt); d.setDate(d.getDate() + days); return { date: d.toISOString().slice(0, 10) } }
    if (completedISO) { const d = new Date(completedISO); d.setDate(d.getDate() + 90); return { date: d.toISOString().slice(0, 10) } }
    return null
  }, [appointments, lastReview, completedISO])

  const stats = [
    ['📈', skinScore, 'Skin Score'],
    ['📅', daysCompleted != null ? daysCompleted : '—', 'Days Completed'],
    ['📸', photoCount, 'Progress Photos'],
    ['🔥', daysSinceCompleted != null ? daysSinceCompleted : 0, 'Days Cared'],
  ]

  const timeline = [
    { icon: '🩺', label: 'Diagnosis', date: diagAppt ? fmtShort(diagAppt.date) : null },
    { icon: '🧑‍⚕️', label: 'Consult', date: firstAppt ? fmtShort(firstAppt.date) : null },
    { icon: '📋', label: 'Treatment Started', date: startISO ? fmtShort(startISO) : null },
    { icon: '📸', label: 'Progress Tracking', date: photoCount ? `${photoCount} photos` : 'Weekly' },
    { icon: '🛡️', label: 'Treatment Completed', date: completedISO ? fmtShort(completedISO) : null },
    { icon: '🌿', label: 'Maintenance Phase', date: 'Now', now: true },
  ]

  const TIPS = [
    ['☀️', 'Use sunscreen daily'],
    ['💧', 'Stay hydrated'],
    ['🌙', 'Sleep well'],
    ['🧘', 'Manage stress'],
    ['🧴', 'Follow your skincare routine'],
  ]

  const stripPhotos = progressPhotos.slice(0, 4).reverse()  // oldest → newest of the recent 4
  const goCare = () => navigate && navigate('/patient-dashboard?view=care')
  const _MONU = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
  const recD = rec ? new Date(rec.date) : null

  const Section = ({ title, action, onAction, children }) => (
    <div style={{ background: '#fff', border: `1px solid ${G.border}`, borderRadius: 18, padding: '1.1rem 1.2rem', marginBottom: 12, boxShadow: '0 2px 10px rgba(13,34,24,.05)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ fontSize: '1rem', fontWeight: 800, color: G.text }}>{title}</div>
        {action && <span onClick={onAction} style={{ fontSize: '.76rem', color: G.g700, fontWeight: 700, cursor: 'pointer' }}>{action} →</span>}
      </div>
      {children}
    </div>
  )

  return (
    <div style={{ minHeight: '100vh', background: '#F8FAF9', fontFamily: FONT, paddingBottom: 90 }}>
      <TopBar />
      <div style={{ padding: '1.1rem 1.2rem 0' }}>
        <NotifBanner notifs={notifs} onDismiss={onDismissNotif} />

        {/* Celebration hero + stats */}
        <div style={{ background: 'linear-gradient(150deg,#0F3D24 0%,#1E6B3C 60%,#2E8B4F 100%)', borderRadius: 20, padding: '1.4rem', marginBottom: 12, position: 'relative', overflow: 'hidden', boxShadow: '0 8px 28px rgba(15,61,36,.28)' }}>
          <div style={{ position: 'absolute', top: -30, right: -20, width: 120, height: 120, borderRadius: '50%', background: 'rgba(255,255,255,.06)' }} />
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, position: 'relative' }}>
            <div style={{ width: 58, height: 58, borderRadius: '50%', background: 'rgba(255,255,255,.16)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.9rem', flexShrink: 0 }}>🛡️</div>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontFamily: SERIF, fontSize: '1.35rem', color: '#fff', lineHeight: 1.15 }}>Amazing progress!</div>
              <div style={{ fontSize: '.95rem', fontWeight: 700, color: 'rgba(255,255,255,.95)', marginTop: 3 }}>Your treatment is complete.</div>
              <div style={{ fontSize: '.76rem', color: 'rgba(255,255,255,.8)', marginTop: 5, lineHeight: 1.45 }}>Keep it up to maintain healthy, glowing skin.</div>
            </div>
          </div>
          <div style={{ height: 1, background: 'rgba(255,255,255,.18)', margin: '1.1rem 0 .9rem' }} />
          <div style={{ display: 'flex', position: 'relative' }}>
            {stats.map(([icon, val, label]) => (
              <div key={label} style={{ flex: 1, textAlign: 'center' }}>
                <div style={{ fontSize: '1rem', marginBottom: 2 }}>{icon}</div>
                <div style={{ fontSize: '1.15rem', fontWeight: 900, color: '#fff', lineHeight: 1 }}>{val}</div>
                <div style={{ fontSize: '.56rem', color: 'rgba(255,255,255,.8)', marginTop: 3, lineHeight: 1.2 }}>{label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Your Journey timeline */}
        <Section title="Your Journey" action="View Details" onAction={onOpenProgress}>
          <div style={{ position: 'relative', paddingTop: 2 }}>
            <div style={{ position: 'absolute', top: 18, left: '9%', right: '9%', height: 2, background: G.g300, zIndex: 0 }} />
            <div style={{ display: 'flex', position: 'relative', zIndex: 1 }}>
              {timeline.map((n, i) => (
                <div key={i} style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 2px' }}>
                  <div style={{ width: 34, height: 34, borderRadius: '50%', background: n.now ? '#fff' : G.g100, border: n.now ? `2px dashed ${G.g500}` : `1px solid ${G.border}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.9rem', flexShrink: 0 }}>{n.icon}</div>
                  <div style={{ width: '100%', height: 26, marginTop: 6, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ width: '100%', fontSize: '.52rem', fontWeight: 700, color: G.text, textAlign: 'center', lineHeight: 1.15, overflowWrap: 'break-word' }}>{n.label}</div>
                  </div>
                  <div style={{ width: '100%', height: 11, fontSize: '.5rem', color: G.mute, textAlign: 'center', lineHeight: 1 }}>{n.date || ''}</div>
                  <div style={{ marginTop: 4, color: G.g500, fontSize: '.66rem', fontWeight: 800 }}>{n.now ? '📍' : '✓'}</div>
                </div>
              ))}
            </div>
          </div>
        </Section>

        {/* Keep Your Skin Healthy — icon tiles */}
        <Section title="Keep Your Skin Healthy" action="View All Tips" onAction={goCare}>
          <div style={{ display: 'flex', gap: 8 }}>
            {TIPS.map(([icon, label]) => (
              <div key={label} style={{ flex: 1, background: G.g50, border: `1px solid ${G.border}`, borderRadius: 12, padding: '.7rem .25rem', textAlign: 'center' }}>
                <div style={{ fontSize: '1.15rem' }}>{icon}</div>
                <div style={{ fontSize: '.54rem', color: G.text, fontWeight: 600, marginTop: 5, lineHeight: 1.25 }}>{label}</div>
              </div>
            ))}
          </div>
        </Section>

        {/* Recommended Review */}
        {rec && recD && (
          <div style={{ background: '#fff', border: `1px solid ${G.border}`, borderRadius: 18, padding: '1.1rem 1.2rem', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 14, boxShadow: '0 2px 10px rgba(13,34,24,.05)' }}>
            <div style={{ width: 54, borderRadius: 12, overflow: 'hidden', flexShrink: 0, border: `1px solid ${G.border}`, textAlign: 'center' }}>
              <div style={{ background: G.g700, color: '#fff', fontSize: '.6rem', fontWeight: 700, padding: '.2rem 0', letterSpacing: '.05em' }}>{_MONU[recD.getMonth()]}</div>
              <div style={{ fontSize: '1.4rem', fontWeight: 900, color: G.g900, padding: '.15rem 0' }}>{String(recD.getDate()).padStart(2, '0')}</div>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '.72rem', color: G.mute, fontWeight: 600 }}>Recommended Review</div>
              <div style={{ fontSize: '1.02rem', fontWeight: 800, color: G.text }}>{fmtNice(rec.date)}</div>
              <div style={{ fontSize: '.7rem', color: G.mute, marginTop: 2, lineHeight: 1.4 }}>{rec.booked ? 'Your review is booked.' : 'Because your treatment has entered the maintenance phase.'}</div>
            </div>
            <div style={{ textAlign: 'center', flexShrink: 0 }}>
              <button onClick={onBookConsult} style={{ background: G.g700, color: '#fff', border: 'none', borderRadius: 10, padding: '.55rem 1rem', fontWeight: 700, fontSize: '.78rem', cursor: 'pointer', fontFamily: FONT, whiteSpace: 'nowrap' }}>{rec.booked ? 'View' : 'Book Now'}</button>
              <div style={{ fontSize: '.56rem', color: G.mute, marginTop: 5 }}>We'll send a reminder</div>
            </div>
          </div>
        )}

        {/* Your Skin Journey — real photo strip */}
        <button onClick={onOpenProgress} style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left', background: '#fff', border: `1px solid ${G.border}`, borderRadius: 18, padding: '1.1rem 1.2rem', marginBottom: 12, cursor: 'pointer', fontFamily: FONT, boxShadow: '0 2px 10px rgba(13,34,24,.05)' }}>
          <div style={{ flexShrink: 0 }}>
            <div style={{ fontSize: '1.4rem' }}>📸</div>
            <div style={{ fontSize: '.95rem', fontWeight: 800, color: G.text, marginTop: 6 }}>Your Skin<br />Journey</div>
            <div style={{ fontSize: '.66rem', color: G.mute, marginTop: 2 }}>See how far<br />you've come</div>
          </div>
          {stripPhotos.length > 0 && (
            <div style={{ flex: 1, display: 'flex', gap: 8, justifyContent: 'flex-end', overflow: 'hidden' }}>
              {stripPhotos.map(p => (
                <div key={p.file} style={{ textAlign: 'center' }}>
                  <div style={{ width: 56, height: 66, borderRadius: 10, overflow: 'hidden', background: G.g50, border: `1px solid ${G.border}` }}>
                    <img src={photoUrl(p.file)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => { e.target.style.display = 'none' }} />
                  </div>
                  <div style={{ fontSize: '.55rem', color: G.mute, marginTop: 3 }}>{p.ts ? fmtShort(p.ts) : ''}</div>
                </div>
              ))}
            </div>
          )}
          <span style={{ color: G.mute, fontSize: '1.2rem', flexShrink: 0 }}>›</span>
        </button>

      </div>
    </div>
  )
}
